import { useQuery } from '@tanstack/react-query';
import { lineItemService } from '@services/lineItem';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const PROJECT_BUDGET_SUMMARY_QUERY_KEY = 'projectBudgetSummary';

export const useGetProjectBudgetSummary = (projectId?: string | null) => {
  const tActionMessages = useTranslation('actionMessages');
  return useQuery({
    queryKey: [PROJECT_BUDGET_SUMMARY_QUERY_KEY, projectId],
    queryFn: async () => {
      try {
        if (!projectId) return null;
        return await lineItemService.getProjectBudgetSummary(projectId);
      } catch (error) {
        toast.error(tActionMessages.errorFetchingProjectBudgetSummary);
        return null;
      }
    },
    enabled: !!projectId,
  });
};
